<template>
    <div class="v-hint-wrapper" ref="wrapperRef" @mouseenter="handleEnter" @mouseleave="handleLeave">
        <slot></slot>

        <Teleport to="body">
            <transition name="fade">
                <div v-if="show && active" class="v-hint" :style="hintStyle" @mouseenter="handleEnter"
                    @mouseleave="handleLeave">
                    {{ text }}
                </div>
            </transition>
        </Teleport>
    </div>
</template>

<script>
import { ref, computed } from 'vue';

export default {
    name: "VHint",
    props: {
        text: {
            type: String,
            default: '',
        },
        position: {
            type: String,
            default: "bottom",
        },
        delay: {
            type: Number,
            default: 1000,
        },
        active: {
            type: Boolean,
            default: false,
        }
    },
    setup(props) {
        const wrapperRef = ref(null);
        const rect = ref(null);

        const hintStyle = computed(() => {
            if (!rect.value) return {};
            const r = rect.value;
            const GAP = 6;

            if (props.position === 'bottom') {
                return {
                    position: 'fixed',
                    top: `${r.bottom + GAP}px`,
                    left: `${r.left + r.width / 2}px`,
                    transform: 'translateX(-50%)',
                };
            }
            if (props.position === 'top') {
                return {
                    position: 'fixed',
                    top: `${r.top - GAP}px`,
                    left: `${r.left + r.width / 2}px`,
                    transform: 'translate(-50%, -100%)',
                };
            }
            if (props.position === 'left') {
                return {
                    position: 'fixed',
                    top: `${r.top + r.height / 2}px`,
                    left: `${r.left - GAP}px`,
                    transform: 'translate(-100%, -50%)',
                };
            }
            if (props.position === 'right') {
                return {
                    position: 'fixed',
                    top: `${r.top + r.height / 2}px`,
                    left: `${r.right + GAP}px`,
                    transform: 'translateY(-50%)',
                };
            }
            return {};
        });

        return { wrapperRef, hintStyle, rect };
    },
    data() {
        return {
            show: false,
            showTimeout: null,
            hideTimeout: null,
        };
    },
    methods: {
        handleEnter() {
            clearTimeout(this.hideTimeout);
            clearTimeout(this.showTimeout);
            this.showTimeout = setTimeout(() => {
                this.rect = this.$refs.wrapperRef?.getBoundingClientRect() ?? null;
                this.show = true;
            }, this.delay);
        },
        handleLeave() {
            clearTimeout(this.showTimeout);
            this.hideTimeout = setTimeout(() => {
                this.show = false;
            }, 150);
        },
    },
};
</script>

<style scoped>
.v-hint-wrapper {
    position: relative;
    display: inline-flex;
    align-items: center;
}

.v-hint {
    background: var(--color-bg-dark);
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
    color: var(--color-text);
    padding: 10px 14px;
    border-radius: 8px;
    font-size: 13px;
    z-index: 19999;
    pointer-events: auto;
    user-select: none;
    max-width: 400px;
}

/* Анимация */
.fade-enter-active,
.fade-leave-active {
    transition: opacity 0.2s ease, transform 0.2s ease;
}

.fade-enter-from,
.fade-leave-to {
    opacity: 0;
    transform: translateY(-5px);
}

.fade-enter-to,
.fade-leave-from {
    opacity: 1;
    transform: translateY(0);
}
</style>
